import { Button, IconButton, InputAdornment, TextField, TextFieldProps } from "@mui/material";
import { Box } from "@mui/system";

import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from '@mui/icons-material/FilterAlt';

export default function SearchWithFilters({
    palavraChave,
    textFieldProps,
    pesquisar,
    setTermoPesquisa = () => { },
    handleOpenFilters,
    hasFilters = true,
}: SearchWithFiltersProps) {

    return (
        <Box display="flex" alignItems="center" justifyContent={'space-between'} gap={2} py={2} mb={2}>
            <TextField
                {...textFieldProps}
                value={palavraChave}
                fullWidth
                slotProps={{
                    input: {
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => pesquisar(palavraChave)}>
                                    <SearchIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        pesquisar(palavraChave);
                    }
                }}
                onChange={(e) => setTermoPesquisa(e.target.value)}
            />
            {
                hasFilters && handleOpenFilters &&
                <Button
                    sx={{ height: '56px' }}
                    variant="outlined"
                    startIcon={<FilterAltIcon sx={{ ml: 1 }} />}
                    onClick={() => handleOpenFilters(true)}
                >
                    Filtros
                </Button>
            }
        </Box>
    )
}

interface SearchWithFiltersProps {
    textFieldProps: TextFieldProps,
    palavraChave: string,
    pesquisar: (term: string) => void,
    setTermoPesquisa?: (value: string) => void,
    handleOpenFilters?: (value: boolean) => void,
    hasFilters?: boolean,
}
